module.exports = __webpack_public_path__ + "media/images/1544923318981-c2cdce21501032bb1a9cee292056eae2eb7014cd33606f9d370f38be32c8745a.jpg";